import {creator} from "d3-selection";

export default function() {
  var parents = [];
  return this.filter(function() {
    if (parents.indexOf(this.parentNode) > -1) return false;
    parents.push(this.parentNode);
    return true;
  }).select(function() {
    return this.parentNode;
  });
}



//////////////////
// WEBPACK FOOTER
// /Users/darlacameron/projects/feature-federal-children-shelters-2018-06/node_modules/d3-jetpack/src/parent.js
// module id = null
// module chunks = 